export default __webpack_public_path__ + "static/media/event-sport-bg.0cedceb6.jpg";